import styled, { css } from 'styled-components';

export const GlobalFilterWrapper = styled.div`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacings[32]};
    padding: ${theme.spacings[20]} ${theme.spacings[24]};
    border: 1.5px solid ${theme.colors.blue600};
    border-radius: ${theme.radius.md};
    background: rgba(1, 122, 198, 0.04);
  `}
`;

export const GlobalFilterHeader = styled.div`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacings[16]};
  `}
`;

export const GlobalFilterTitle = styled.span`
  ${({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: ${theme.spacings[6]};
    color: ${theme.colors.blue600};
    font-size: ${theme.font.sizes.xs};
    font-weight: ${theme.font.weights.bold};
    letter-spacing: 0.08em;
    text-transform: uppercase;

    svg {
      font-size: ${theme.font.sizes.md};
    }
  `}
`;

export const GlobalFilterDescription = styled.p`
  ${({ theme }) => css`
    margin-top: ${theme.spacings[6]};
    color: ${theme.colors.gray600};
    font-size: ${theme.font.sizes.xs};
    line-height: 1.5;
    max-width: 55ch;
  `}
`;

export const FilterPanel = styled.form``;

export const FilterFields = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: ${theme.spacings[12]};
  `}
`;

export const Field = styled.div`
  ${({ theme }) => css`
    min-width: 14rem;
    flex: 1 1 16rem;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings[4]};

    label {
      color: ${theme.colors.blueGray700};
      font-size: ${theme.font.sizes.xxs};
      font-weight: ${theme.font.weights.semiBold};
    }

    input {
      width: 100%;
      height: 3.8rem;
      padding: 0 ${theme.spacings[10]};
      border: 1px solid #cdd3df;
      border-radius: ${theme.radius.xs};
      outline: 0;
      background: ${theme.colors.white};
      color: ${theme.colors.gray900};
      font-family: ${theme.font.family.default};
      font-size: ${theme.font.sizes.xs};

      &:focus {
        border-color: ${theme.colors.blue600};
        box-shadow: 0 0 0 3px rgba(1, 122, 198, 0.12);
      }
    }
  `}
`;

export const SubmitButton = styled.button`
  ${({ theme }) => css`
    height: 3.8rem;
    padding: 0 ${theme.spacings[16]};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacings[6]};
    border-radius: ${theme.radius.xs};
    background: ${theme.colors.blue600};
    color: ${theme.colors.white};
    font-family: ${theme.font.family.default};
    font-size: ${theme.font.sizes.xs};
    font-weight: ${theme.font.weights.bold};
    transition: background 0.2s;
    white-space: nowrap;

    &:hover {
      background: ${theme.colors.blue700};
    }

    @media (max-width: 580px) {
      width: 100%;
    }
  `}
`;

export const ClearButton = styled.button`
  ${({ theme }) => css`
    height: 3.8rem;
    padding: 0 ${theme.spacings[16]};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacings[6]};
    border: 1px solid ${theme.colors.blue600};
    border-radius: ${theme.radius.xs};
    background: ${theme.colors.white};
    color: ${theme.colors.blue600};
    font-family: ${theme.font.family.default};
    font-size: ${theme.font.sizes.xs};
    font-weight: ${theme.font.weights.bold};
    transition: background 0.2s, border-color 0.2s, color 0.2s;

    &:hover {
      border-color: ${theme.colors.blue700};
      background: rgba(1, 122, 198, 0.08);
      color: ${theme.colors.blue700};
    }

    @media (max-width: 580px) {
      width: 100%;
    }
  `}
`;

export const FormError = styled.p`
  ${({ theme }) => css`
    margin-top: ${theme.spacings[10]};
    color: ${theme.colors.error};
    font-size: ${theme.font.sizes.xxs};
  `}
`;
